import { render, staticRenderFns } from "./DownloadItem.vue?vue&type=template&id=2650a4e8&scoped=true&"
import script from "./DownloadItem.vue?vue&type=script&lang=js&"
export * from "./DownloadItem.vue?vue&type=script&lang=js&"
import style0 from "./DownloadItem.vue?vue&type=style&index=0&id=2650a4e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2650a4e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2650a4e8')) {
      api.createRecord('2650a4e8', component.options)
    } else {
      api.reload('2650a4e8', component.options)
    }
    module.hot.accept("./DownloadItem.vue?vue&type=template&id=2650a4e8&scoped=true&", function () {
      api.rerender('2650a4e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/DownloadItem.vue"
export default component.exports